export const renameStatisticsKeyToString = (key: string) => {
  if (key === '1-30') {
    return 'soldRecently';
  }

  if (key === '31-90') {
    return 'sold';
  }

  return 'current';
};
